import './Avatar.css'

/**
 * Avatar - Componente para exibir foto de perfil ou iniciais
 * 
 * Funcionalidades:
 * - Exibe imagem se disponível
 * - Fallback para iniciais baseadas no nome
 * - Tamanhos variáveis (sm, md, lg)
 * - Suporte a dark mode
 */
function Avatar({ name, email, imageUrl, size = 'md' }) {
  // Obter iniciais do nome
  const getInitials = () => {
    if (!name) return 'U'
    const parts = name.trim().split(' ')
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase()
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
  }

  // Gerar cor de fundo baseada no nome (para consistência)
  const getBackgroundColor = () => {
    if (!name) return '#6b7280'
    
    const colors = [
      '#3b82f6', // azul
      '#10b981', // verde
      '#f59e0b', // amarelo
      '#ef4444', // vermelho
      '#8b5cf6', // roxo
      '#ec4899', // rosa
      '#06b6d4', // ciano
      '#f97316', // laranja
    ]
    
    let hash = 0
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    return colors[Math.abs(hash) % colors.length]
  }

  const initials = getInitials()
  const bgColor = getBackgroundColor()

  return (
    <div className={`avatar avatar-${size}`} style={{ backgroundColor: bgColor }}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name || 'Avatar do usuário'}
          className="avatar-image"
          onError={(e) => {
            // Se a imagem falhar ao carregar, mostra as iniciais
            e.target.style.display = 'none'
            const initialsSpan = e.target.nextElementSibling
            if (initialsSpan) {
              initialsSpan.style.display = 'flex'
            }
          }}
        />
      ) : null}
      <span 
        className="avatar-initials" 
        style={{ display: imageUrl ? 'none' : 'flex' }}
      >
        {initials}
      </span>
    </div>
  )
}

export default Avatar

